// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3mObx","main-nav":"Header_main-nav__1pKe9","brand":"Header_brand__2MCxw","controls":"Header_controls__3rR-g","divider":"Header_divider__3oRKq"};